import { BaseAlert, Button } from '@/dc-shared-web/src'
import { faCheckCircle } from '@document-crunch/pro-regular-svg-icons'
import { FC } from 'react'

type Step3Props = {
  onClose: () => void
}

export const Step3: FC<Step3Props> = ({ onClose }) => {
  return (
    <div className='tw-space-y-4'>
      <BaseAlert
        variant='info'
        icon={faCheckCircle}
        description={
          <div className='tw-text-base'>
            <p>The new version of this document is processing.</p>
            <p>
              Once it has finished processing,{' '}
              <strong>
                you will see a &apos;Multiple versions&apos; label next to the
                crunch name
              </strong>
              .
            </p>
          </div>
        }
      />
      <div className='tw-flex tw-items-center tw-justify-end tw-gap-2'>
        <Button onClick={onClose} variant='outline' data-testid='close-button'>
          Close
        </Button>
      </div>
    </div>
  )
}
